"use strict";

var marko_template = module.exports = require("marko/dist/vdom").t(),
    marko_classValue = require("marko/dist/runtime/helpers/class-value"),
    components_registry_browser = require("marko/dist/runtime/components/registry-browser"),
    marko_registerComponent = components_registry_browser.r,
    marko_componentType = marko_registerComponent("/MP.WEB$2.0/src/views/smoothy~1.0/components/FormAlert.marko", function() {
      return module.exports;
    }),
    marko_renderer = require("marko/dist/runtime/components/renderer"),
    marko_defineComponent = require("marko/dist/runtime/components/defineComponent"),
    Locale_template = require("../../components/Locale/index.marko"),
    marko_loadTag = require("marko/dist/runtime/helpers/load-tag"),
    Locale_tag = marko_loadTag(Locale_template);

function render(input, out, __component, component, state) {
  var data = input;

  if (input.alert) {
    out.be("div", {
        "class": marko_classValue(input.class)
      }, "0", component, null, 1);

    out.be("div", {
        "class": marko_classValue(marko_classValue([
          "alert",
          "border-" + input.alert.type
        ]))
      }, "1", component, null, 1);

    Locale_tag({
        text: input.alert.message
      }, out, __component, "2");

    out.ee();

    out.ee();
  }
}

marko_template._ = marko_renderer(render, {
    d_: true,
    e_: marko_componentType
  });

marko_template.Component = marko_defineComponent({}, marko_template._);
